import { mergeStyles } from '@fluentui/react';
import { PersonFilled } from '@fluentui/react-icons';
import React from 'react';

const containerStyles = mergeStyles({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: 500,

    // display: inline-flex;
    // padding: 0px 4px;
    // align-items: center;
});

const textStyles = mergeStyles({
    color: '#F9FAFB',
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px', // 153.846%
    letterSpacing: '0.52px',
});


interface NumberOfParticipantsIconProps {
    numberOfParticipants: number;
}

export const NumberOfParticipantsIcon = (props: NumberOfParticipantsIconProps): JSX.Element => {
    const { numberOfParticipants } = props;

    return (
        <div className={containerStyles}>
            <PersonFilled fontSize={14} />
            <span className={textStyles}>{numberOfParticipants}</span>
        </div>
    );
};
